import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { OndernemingService } from 'src/app/services/onderneming.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Cash4BikeService } from 'src/app/services/cash4-bike.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from 'src/app/services/data.service';
import { IFormGroup, IFormBuilder } from '@rxweb/types';
import { Cash4Bike } from 'src/app/models/Cash4Bike';
import { mergeMap, take } from 'rxjs/operators';
import { ModalContentComponent } from 'src/app/shared/modal-content/modal-content.component';
import { Onderneming } from 'src/app/models/Onderneming';

@Component({
  selector: 'app-admin-cash4bike',
  templateUrl: './admin-cash4bike.component.html',
  styleUrls: ['./admin-cash4bike.component.scss']
})
export class AdminCash4bikeComponent implements OnInit {
  @Input() ondernemingNaam: string;

 //form variabelen
  formBuilder: IFormBuilder;
  onderneming: Onderneming;
  cash4BikeFormGroup: IFormGroup<Cash4Bike>;
  err = [ "Dit veld is verplicht."];
  cash4Bike: Cash4Bike = {
    tekstJaarlijkseLeaseKost:"",
    tekstBrutoPerJaar:"",
     tekstDetailsPatronaleRSZ:"",
    infoPatronaleRSZ: "",
     tekstWaarschuwing:""

  }
  constructor(
    private cash4BikeService: Cash4BikeService,
      formBuilder: FormBuilder,
    private modalService: NgbModal,
    public dataService: DataService,
    private cdref: ChangeDetectorRef


  ) {
       this.formBuilder = formBuilder
    }

  ngOnInit(): void {
     this.cash4BikeFormGroup = this.formBuilder.group<Cash4Bike>({
       tekstJaarlijkseLeaseKost: this.formBuilder.control(null,[Validators.required]),
    tekstBrutoPerJaar: this.formBuilder.control(null,[Validators.required]),
     tekstDetailsPatronaleRSZ: this.formBuilder.control(null,[Validators.required]),
     infoPatronaleRSZ: this.formBuilder.control(null,[Validators.required]),
     tekstWaarschuwing: this.formBuilder.control(null,[Validators.required])
     })
  this.getData();
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
 }
  getData()
  {
    // if (this.dataService.onderneming == undefined || this.dataService.onderneming.naam.toLowerCase() != ondernemingNaam.toLowerCase()) {
      
    //   this.ondernemingService.getOnderneming(ondernemingNaam).pipe(
    //     mergeMap((onderneming) => {
    //       this.dataService.onderneming = onderneming;
    //       localStorage.setItem('onderneming', JSON.stringify(this.dataService.onderneming.naam));
    //       console.log("laden van onderneming");
    //       return this.cash4BikeService.getCash4Bike(this.dataService.onderneming?.cash4Bike);
    //     }),
    //     take(1))
    //     .subscribe(e => {

    //       this.cash4Bike = e;
    //       err => console.log(err);
    //     });
    // }
    // else {
    //   this.getCash4Bike(this.dataService.onderneming.cash4Bike);
    // }
    this.onderneming = this.dataService?.getOnderneming();
    this.getCash4Bike(this.onderneming.cash4Bike);
  
  }
  getCash4Bike(id: string) {
    if (this.dataService.cash4Bike == undefined) {
      this.cash4BikeService.getCash4Bike(id).pipe(
        take(1))
        .subscribe(e => {
          this.cash4Bike = e;
          this.cdref.markForCheck();
        });
    }
    else
    {
      this.cash4Bike = this.dataService.cash4Bike;
    }
    
  }
  async onSubmit() {
    if (this.cash4BikeFormGroup.invalid) {
       return;
     }
    const modalRef = this.modalService.open(ModalContentComponent);
    modalRef.componentInstance.confirmationBoxTitle = 'Bevestiging';
    modalRef.componentInstance.confirmationMessage = 'Weet u zeker dat u deze gegevens wilt opslaan?';

    const userResponse = await modalRef.result;
    if (userResponse) {
      this.opslaan();
    }
  }
  opslaan()
  {
    this.cash4BikeService.updateCash4Bike(this.cash4Bike);

  }

}
